import React from 'react';
import PropTypes from 'prop-types';
import { Config, getCookie, getCustomerValues, setCustomerValues, getInputError, getFormErrors } from '@deporvillage/utils-library-component';
import Modal from '@deporvillage/modal-component';
import Register from './Register';
import Customer from './utils/customer';
import CustomerNoGender from './utils/customerNoGender';

import styles from './RegisterPopup.module.scss';

const RegisterPopup = ({ isOpen, onClose, onBack }) => {
    const [registerError, setRegisterError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const { api, country } = React.useContext(Config);

    // TODO remove ternary after 3 weeks in prod
    const [customerData, setCustomerData] = React.useState(setCustomerValues(country?.code !== 'PT' ? CustomerNoGender : Customer));

    const handleOnModalClose = () => {
        onClose && onClose();
    };

    // istanbul ignore next
    const handleOnInputChange = (input, form) => {
        const validateInput = {
            ...form,
            [input.id]: {
                ...input,
                error: getInputError(input, form),
            },
        };
        setCustomerData(validateInput);
        setRegisterError(false);
    };

    // istanbul ignore next
    const postCustomerRegister = async (api, payload) => {
        const tokenMd5 = getCookie('token_md5');
        return fetch(`${api}/user/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                country: country.code,
                'dpv-session': getCookie('dpv-session'),
                ...(!tokenMd5 ? {} : { 'token-app': tokenMd5 }),
            },
            credentials: 'include',
            body: JSON.stringify(payload),
        })
            .then((ans) => ans)
            .catch((e) => console.log(e));
    };

    // istanbul ignore next
    const handleOnRegister = async (form) => {
        const [result, hasErrors] = getFormErrors(form);
        if (hasErrors) {
            setCustomerData(result);
        } else {
            setLoading(true);
            const res = await postCustomerRegister(api, getCustomerValues(customerData));
            /* eslint-disable no-undef */
            if (res.status === 200) {
                window.location.reload();
            } else {
                setLoading(false);
                setRegisterError(true);
            }
        }
    };

    return (
        isOpen && (
            <div
                className={`${styles['register-popup-component']} ${
                    !onClose ? styles['fixed-close'] : ''
                } ${!onBack ? styles['fixed-back'] : ''}`}
            >
                <Modal onClose={handleOnModalClose} onBack={() => onBack && onBack()}>
                    <div className={`${loading ? styles['loading'] : ''}`}>
                        <Register
                            customerData={customerData}
                            onChange={handleOnInputChange}
                            onRegister={handleOnRegister}
                            error={registerError}
                        />
                    </div>
                </Modal>
            </div>
        )
    );
};

RegisterPopup.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
};

export default RegisterPopup;
